import React, { useState } from "react";
import { Form, Button, Card, Container, Row, Col, Alert, NavbarBrand } from "react-bootstrap";

function Register() {
    const [step, setStep] = useState(1);
    const [form, setForm] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: ""
    });
    const [activationCode, setActivationCode] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        setSuccessMsg("");
        setLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/register/admin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(form)
            });

            const data = await response.json();

            if (data.status === true) {
                setSuccessMsg(data.data);
                setStep(2); // ✅ Move to activation step UI
            } else {
                setErrorMsg(data.apiError?.validationErrors?.join(", ") || data.message);
            }
        } catch (error) {
            setErrorMsg("Network error. Try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyCode = async (e) => {
        e.preventDefault();
        setErrorMsg("");
        setSuccessMsg("");
        setLoading(true);

        console.log("Verify code:", activationCode);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/auth/activate-account?token=${activationCode}`,
                {
                    method: "GET"
                }
            );

            const data = await response.json();


            if (data.status === true) {
                setSuccessMsg(data.data || "Account activated successfully!");

                // ✅ Redirect to login after short delay
                setTimeout(() => {
                    window.location.href = "/login";
                }, 300);
            } else {
                setErrorMsg(
                    data.apiError?.error || data.message || "Invalid activation token"
                );
            }
        } catch (error) {

            setErrorMsg("Network error. Please try again.");
        } finally {
            setLoading(false);
        }

    };

    return (
        <Container fluid className="d-flex justify-content-center align-items-center vh-100 bg-body-tertiary">
            <Row className="w-100 justify-content-center">
                <Col md={4}>
                    <Card className="shadow p-4">
                        <Card.Body>

                            <NavbarBrand href="/" className="fs-4 mb-4">KarmanTrener <span className="text-body-emphasis" >.COM</span> </NavbarBrand>

                            <h3 className="text-center mt-4 mb-4 fw-bold">
                                {step === 1 ? "Register" : "Verify Email"}
                            </h3>

                            {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
                            {successMsg && <Alert variant="success">{successMsg}</Alert>}

                            {step === 1 && (
                                <Form onSubmit={handleRegister}>
                                    <Form.Group className="mb-3 text-start">
                                        <Form.Label>First Name</Form.Label>
                                        <Form.Control
                                            name="firstname"
                                            type="text"
                                            placeholder="Enter first name"
                                            value={form.firstname}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 text-start" >
                                        <Form.Label>Last Name</Form.Label>
                                        <Form.Control
                                            name="lastname"
                                            type="text"
                                            placeholder="Enter last name"
                                            value={form.lastname}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 text-start">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            name="email"
                                            type="email"
                                            placeholder="Enter email"
                                            value={form.email}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3 text-start">
                                        <Form.Label >Password</Form.Label>
                                        <Form.Control
                                            name="password"
                                            type="password"
                                            placeholder="Enter password"
                                            value={form.password}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>

                                    <Button variant="primary" type="submit" className="w-100 py-2 fw-semibold">
                                        Sign Up
                                    </Button>

                                    <div className="text-center mt-3">
                                        <a href="/login">Already have an account? Login</a>
                                    </div>
                                </Form>
                            )}

                            {step === 2 && (
                                <Form onSubmit={handleVerifyCode}>
                                    <Form.Group className="mb-3 text-start" >
                                        <Form.Label>Enter Activation Code</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="XXXXXX"
                                            value={activationCode}
                                            onChange={(e) => setActivationCode(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Button disabled={loading} variant="success" type="submit" className="w-100 py-2 fw-semibold">
                                        {loading ? "Verifying..." : "Verify"}
                                    </Button>


                                    <div className="text-center mt-3">
                                        <a href="/login">Back to Login</a>
                                    </div>
                                </Form>
                            )}

                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default Register;
